import { Maybe } from '../../../__generated__/globalTypes'

import minimalSponsorFragmentRawString from '../MinimalSponsorFragment.graphql'

export const minimalSponsorFragmentString = minimalSponsorFragmentRawString

export type MinimalSponsorFragment = {
  __typename: 'User'
  id: string
  firstName: string
  lastName: string
  email: string
  genealogyId: number
  storefront: Maybe<{
    slug: Maybe<string>
    mugshot: Maybe<{
      url: string
    }>
    biography: Maybe<string>
  }>
}

export const isMinimalSponsorFragment = (
  fragment: any,
): fragment is MinimalSponsorFragment =>
  fragment &&
  fragment.__typename === 'User' &&
  typeof fragment.id === 'string' &&
  typeof fragment.firstName === 'string' &&
  typeof fragment.lastName === 'string' &&
  typeof fragment.email === 'string' &&
  typeof fragment.genealogyId === 'number' &&
  (fragment.storefront === null ||
    (fragment.storefront &&
      (fragment.storefront.slug === null ||
        typeof fragment.storefront.slug === 'string') &&
      (fragment.storefront.mugshot === null ||
        (fragment.storefront.mugshot &&
          typeof fragment.storefront.mugshot.url === 'string')) &&
      (fragment.storefront.biography === null ||
        typeof fragment.storefront.biography === 'string')))
